module.exports = __webpack_public_path__ + "04_bob_brown.83ed0fb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/04_bob_brown.png
// module id = VJex
// module chunks = 0